module.exports = __webpack_public_path__ + "img/a.a8fb03cd.jpg";